"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tenderPricing = void 0;
const enums_1 = require("@bemlo/enums");
exports.tenderPricing = {
    [enums_1.TenderPricing.PROCURED]: 'Procured pricing',
    [enums_1.TenderPricing.FREE]: 'Free pricing',
};
